import script from "./BusyIndicator.vue?vue&type=script&lang=ts&setup=true"
export * from "./BusyIndicator.vue?vue&type=script&lang=ts&setup=true"

import "./BusyIndicator.vue?vue&type=style&index=0&id=5e92ba0d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e92ba0d"]])

export default __exports__